import dayjs, { Dayjs } from 'dayjs';
import { RangeValue, TimeActive } from './type';
import { message } from '@maxtropy/components';

export const TimePickerUtil = (activeKey: TimeActive) => {
  if (activeKey === TimeActive.THIS_MONTH) {
    return 'month';
  } else if (activeKey === TimeActive.THIS_WEEK) {
    return 'week';
  } else {
    return 'date';
  }
};

export const defaultNodeRangeValue = (
  activeKey: TimeActive,
  setNodeRangeValue: React.Dispatch<React.SetStateAction<[Dayjs, Dayjs]>>
) => {
  if (activeKey === TimeActive.CUSTOM || activeKey === TimeActive.HOUR) {
    // 近31天，不包括当天
    const end = dayjs().subtract(1, 'day').endOf('day');
    const start = end.clone().subtract(30, 'day').startOf('day');
    setNodeRangeValue([start, end]);
  } else if (activeKey === TimeActive.THIS_WEEK) {
    // 最近12周（包含当前周）
    const end = dayjs().endOf('week');
    const start = end.clone().subtract(11, 'week').startOf('week');
    setNodeRangeValue([start, end]);
  } else if (activeKey === TimeActive.THIS_MONTH) {
    // 最近12个月（包含当前月）
    const end = dayjs().endOf('month');
    const start = end.clone().subtract(11, 'month').startOf('month');
    setNodeRangeValue([start, end]);
  }
};

export const onChangePicker = (
  dates: RangeValue,
  activeKey: TimeActive,
  setValue: React.Dispatch<React.SetStateAction<RangeValue>>
) => {
  let isFlag = true;
  switch (activeKey) {
    case TimeActive.THIS_MONTH:
      if (dates?.[0] && dates?.[1] && dates[1].startOf('month').diff(dates[0].startOf('month'), 'month') + 1 > 24) {
        isFlag = false;
        message.error('最多选择24个月');
      }
      break;
    case TimeActive.THIS_WEEK:
      if (dates?.[0] && dates?.[1] && dates[1].startOf('week').diff(dates[0].startOf('week'), 'week') + 1 > 24) {
        message.error('最多选择24周');
        isFlag = false;
      }
      break;
    case TimeActive.CUSTOM:
      if (dates?.[0] && dates?.[1]) {
        const days = dates[1].diff(dates[0], 'day');
        if (days > 30) {
          isFlag = false;
          message.error('最多选择30天');
        }
      }
      break;
    case TimeActive.HOUR:
      if (dates?.[0] && dates?.[1]) {
        const days = dates[1].diff(dates[0], 'day');
        if (days > 30) {
          isFlag = false;
          message.error('最多选择30天');
        }
      }
      break;
  }
  if (isFlag) {
    setValue(dates);
  }
};

// 根据 activeKey 决定日期格式
export const formatByKeyDate = (ts: unknown, activeKey: TimeActive) => {
  const date = dayjs(ts as string);
  switch (activeKey) {
    case TimeActive.CUSTOM: // 按日
      return date.format('YYYY-MM-DD');
    case TimeActive.HOUR: // 按小时
      return date.format('YYYY-MM-DD HH');
    case TimeActive.THIS_WEEK: // 按周
      return `${date.format('YYYY')}-第${date.week()}周`;
    case TimeActive.THIS_MONTH: // 按月
      return date.format('YYYY-MM');
    default:
      return date.format('YYYY-MM-DD');
  }
};

// 处理默认时间范围
export const getDefaultRangeDate = (from?: string, to?: string): [Dayjs, Dayjs] => {
  if (from && to) {
    console.log('from,to', from, to);
    return [dayjs(Number(from)), dayjs(Number(to))];
  }
  return [dayjs().subtract(30, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')];
};

// 处理默认activeKey
export const getDefaultActiveKey = (urlActiveKey?: string) => {
  if (urlActiveKey && Object.values(TimeActive).includes(urlActiveKey as TimeActive)) {
    return urlActiveKey as TimeActive;
  }
  return TimeActive.CUSTOM;
};
